
import { useEffect, useState } from "react";
import { Search } from "../../../assets/icons";

export default function CatalogSearchSection({
	title,
	placeholder,
	initQuery,
	onSearch,
}) {
	const [query, setQuery] = useState(initQuery ?? "");

	useEffect(() => {
		setQuery(initQuery ?? "");
	}, [initQuery]);

	function submitSearch() {
		onSearch((query ?? "").trim());
	}

	return (
		<section
			className="relative w-full overflow-hidden rounded-[16px] border border-darkBlue/10 bg-gradient-to-br from-white via-lightCta/80 to-white shadow-[0_10px_28px_rgba(39,106,166,0.1)]"
			aria-label={title}
		>
			<div
				className="h-[3px] w-full bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
				aria-hidden
			/>

			<div className="px-4 py-5 md:px-6 md:py-6">
				<p className="font-Vazir-600 text-[17px] md:text-[18px] text-darkBlue text-center tracking-tight">
					{title}
				</p>

				<div className="mt-4 md:mt-5 mx-auto flex w-full max-w-[420px] flex-col gap-3 sm:flex-row sm:items-stretch">
					<div
						className={[
							"flex min-h-[44px] flex-1 items-center gap-2 rounded-[12px] border-2 border-darkBlue/15 bg-white",
							"px-3 py-2 transition-[border-color,box-shadow] duration-200",
							"focus-within:border-cta/70 focus-within:shadow-[0_0_0_3px_rgba(255,106,75,0.15)]",
						].join(" ")}
					>
						<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-lightCta text-cta">
							<Search />
						</span>
						<input
							type="search"
							value={query}
							onChange={(e) => setQuery(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									submitSearch();
								}
							}}
							placeholder={placeholder}
							className="min-w-0 flex-1 border-0 bg-transparent font-Vazir-400 text-[14px] text-darkBlue outline-none placeholder:text-darkBlue/35"
							dir="rtl"
							autoComplete="off"
						/>
					</div>

					<button
						type="button"
						onClick={submitSearch}
						className={[
							"shrink-0 rounded-[12px] px-5 py-2.5 font-Vazir-600 text-[14px] text-white",
							"bg-gradient-to-l from-cta to-[#FF825E] shadow-[0_4px_14px_rgba(255,106,75,0.35)]",
							"transition hover:brightness-105 active:scale-[0.98]",
							"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-darkBlue/30 focus-visible:ring-offset-2",
						].join(" ")}
					>
						جستجو
					</button>
				</div>
			</div>
		</section>
	);
}
